import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {changeUserTourAutoStart, collapsedSidebarAction, setContactUsDialogMessage, startUserTour} from '../actions';
import ContactUsDialog from '../components/Dialogs/ContactUsDialog';
import DefaultTemplateRecognitionDialog from '../components/Dialogs/DefaultTemplateRecognitionDialog';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import PreloadHeader from '../components/PreloadLayout/PreloadHeader';
import PreloadSidebar from '../components/PreloadLayout/PreloadSidebar';
import TourComponent from '../components/Tour';
import AppConfig from '../config/AppConfig';
import {accessTokenLocalStorageKey, resourceCustomUsers} from '../constants';
import {simpleDataProvider} from '../fetchApi';
import storage from '../fetchApi/storage';
import {GET_ONE} from '../fetchApi/types';
import SidebarContent from '../layout/Sidebar';

class MainApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingHeader: true,
            loadingSidebar: true,
        };
    }

    UNSAFE_componentWillMount() {
        this.updateDimensions();
    }

    componentDidMount() {
        const {windowWidth} = this.state;
        window.addEventListener('resize', this.updateDimensions);
        if (AppConfig.enableUserTour && windowWidth > 600) {
            const accessToken = storage.load(accessTokenLocalStorageKey);
            simpleDataProvider(GET_ONE, resourceCustomUsers, {id: accessToken.userId, include: {relation: 'configuration'}})
                .then(data => {
                        const user = data.data;
                        if (user && user.configuration) {
                            if (user.configuration.enableUserTour) {
                                // Set timeout to give time to render all layout
                                setTimeout(() => {
                                    this.props.startUserTour();
                                }, 1000);
                            }
                            this.props.changeUserTourAutoStart(user.configuration.enableUserTour);
                        }
                    },
                )
                .catch(e => {
                    console.error(e);
                });
        }
        setTimeout(() => {
            this.setState({loadingHeader: false, loadingSidebar: false});
        }, 120);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {windowWidth} = this.state;
        if (nextProps.location !== this.props.location) {
            if (windowWidth <= 1199) {
                this.props.collapsedSidebarAction(false);
            }
        }
    }

    updateDimensions = () => {
        this.setState({windowWidth: window.innerWidth, windowHeight: window.innerHeight});
    };

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);
        }
    }

    renderPage() {
        const {pathname} = this.props.location;
        const {children} = this.props;
        const found = pathname.match(/^\/documents\/([0-9]+)/i);
        if (found && found.length === 2) {
            return (
                <div className="scroller">
                    <div className="rct-page-content">
                        {children}
                    </div>
                </div>
            );
        }
        return (
            <div className="scroller">
                <div className="rct-page-content">
                    {children}
                    <Footer />
                </div>
            </div>
        );
    }

    // render header
    renderHeader() {
        const {loadingHeader} = this.state;
        if (loadingHeader) {
            return <PreloadHeader />;
        }
        return <Header />;
    }

    //render Sidebar
    renderSidebar() {
        const {loadingSidebar} = this.state;
        if (loadingSidebar) {
            return <PreloadSidebar />;
        }
        return <SidebarContent />;
    }

    handleContactUsDialogClose = () => {
        const {setContactUsDialogMessage} = this.props;
        setContactUsDialogMessage('');
    };

    render() {
        const {settings} = this.props;

        return (
            <div className="app">
                <div className="app-main-container">
                    <TourComponent />
                    {this.renderSidebar()}
                    <div className="app-container">
                        <div className="rct-app-content">
                            <div className="app-header">{this.renderHeader()}</div>
                            <div className="rct-page">{this.renderPage()}</div>
                        </div>
                    </div>
                </div>
                <ContactUsDialog open={!!(settings.contactUsDialogMessage)} handleClose={this.handleContactUsDialogClose} />
                <DefaultTemplateRecognitionDialog />
            </div>
        );
    }
}

// map state to props
const mapStateToProps = ({settings}) => {
    return {settings};
};

export default withRouter(
    connect(mapStateToProps, {
        collapsedSidebarAction,
        startUserTour,
        changeUserTourAutoStart,
        setContactUsDialogMessage,
    })(MainApp),
);
